import { Injectable } from "@angular/core";
import { HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Util } from "./util";
import { Component, Input } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Location } from "@angular/common";
import * as CryptoJS from "crypto-js"; // Import crypto-js

@Injectable()
export class HttpServer {
  private apiUrl =
    "https://us-west2-center-store-inventory-dev.cloudfunctions.net/GetAuthToken";
  private client_id = "245785768623";
  private client_secret =
    "f7913e54fa4a50cd95340ab7f1746c715d3156e918hc6bbaf204e772210408v";
  private apiKey = "";

  constructor(
    private util: Util,
    private loc: Location,
  ) {}

  SendData(
    model: any,
    url: any,
    mode: string,
    isBannerNeed = true,
    isDirectUrl = false,
    token = null,
    bannerId = "1",
  ) {
    // Build API URL


    if (isDirectUrl === true) {
      url = url;
    } else {
      const devOnlyApis = [
        "verify-csi-login",
        "GetCSIInventoryDashboardDetails",
        "GetCSIInventoryDetailsByGroups",
        "GetCSIInventoryDetailsByGroup",
        "getCSILibraryValues",
        "AddUpdateConfigType",
        "AddUpdateCSIDepartment",
        "GetRollEntryReportExcelDownload",
        "AddCSINewUserRegister",
        "AddUpdateCSIStoreReceivingLogs",
        "AddUpdateCSIUPCCorrection",
        "AddUpdateCSIUsers",
        "AddUpdateDeleteCSIVendor",
        "AddUpdateDeleteCSIVendorSchedule",
        "ApproveInvoicePeriod",
        "ApproveRejectInventoryCorrections",
        "createInventoryCorrections",
        "CSGrossProfitSummaryComments",
        "CSIResetUserPassword",
        "CSIResetUserPassword",
        "ForcedInventoryExcelDownload",
        "getGrossProfitMasterData",
        "GetCSGrossProfitSummaryExcelDownload",
        "GetCSGrossProfitSummaryExcelDownloadALL",
        "GetCSIStoreReceivingLogs",
        "GetCSGrossProfitSummary",
        "GetCSIInventoryBalanceAndRebates",
        "GetCSIInventorydetailsExcel",
        "GetCSIInventoryReportGroupDetails",
        "getCSIReportData",
        "getCostSummary",
        "GetMonthlyCutOffReportExcel",
      ];

      const isDevOnlyApi = devOnlyApis.some((api) => url.includes(api));

      if (isDevOnlyApi) {
        url = environment.devnewShoreAPI + "/" + url;
      } else if (this.util.isProd()) {
        url = environment.prodShoreAPI + "/" + url;
      } else if (this.util.isUAT()) {
        url = environment.uatShoreAPI + "/" + url;
      } else if (this.util.isDev()) {
        url = environment.devShoreAPI + "/" + url;
      } else {
        url = environment.uatShoreAPI + "/" + url;
      }
    }

    // Headers
    let headers: any = {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "",
      Banner: "",
    };

    // Banner logic
    if (url.includes("7py8fahnf3") || url.includes("llz1npmgm7")) {
      if (bannerId != null && bannerId.toString() === "2") {
        headers.Banner = "lucky";
      } else if (bannerId != null && bannerId.toString() === "3") {
        headers.Banner = "foodmaxx";
      } else {
        headers.Banner = "savemart";
      }
    }

    // Remove Banner header if empty
    if (!this.util.IsNotEmpty(headers.Banner)) {
      delete headers.Banner;
    }

    // --------------------------------------------------
    // CSRF / Authorization logic
    // --------------------------------------------------

    const isMainApi =
      url.includes("https://main-api-dev") ||
      url.includes("https://main-api-prod");

    if (isMainApi) {
      const csrfToken = localStorage.getItem("csrftoken");

      if (csrfToken) {
        headers["X-CSRF-Token"] = csrfToken;
      }

      delete headers.Authorization;
    } else {
      if (!this.util.IsNotEmpty(token)) {
        token = this.util.getToken();
      }

      if (this.util.IsNotEmpty(token)) {
        headers.Authorization = "Bearer " + token;
      }
    }
    const fetchOptions: RequestInit = {
      method: mode ? mode.toUpperCase() : "GET",
      headers,
      body: model ? JSON.stringify(model) : null,
      ...(isMainApi && { credentials: "include" }),
    };

    console.log("CSRF:", headers["X-CSRF-Token"]);
    console.log("Request:", fetchOptions);

    return fetch(url, fetchOptions).then((response) => {
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      return response.json();
    });
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = "Unknown error!";
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }

  getAuthToken(): Promise<string> {
    this.apiUrl =
      "https://us-west2-tsmc-workbench-dev.cloudfunctions.net/getAuthToken";
    this.apiKey =
      "vA4hWVw85E6yxeniw7c8NJY8oVVTbeVk_aoo2V1rDug=:gAAAAABnx-BlMhmdn9KohaZcMeP7JEmD1n1H3xxLGwUkkrB-DMwBaUGox7hgj5f537gCrUY9i5_a9zu8EsiA1Af66g-sIS0WLHiycejS7pbu_CF0y4XPpGt19qRu-8FsIeI59zD99uel20NApJHYi46_erflHnBYpmLU2Niqa6v84FF9MLVRci4=";
    this.util.setlocation(location);
    if (this.util.isProd()) {
      this.apiUrl =
        "https://us-west2-tsmc-workbench-prod.cloudfunctions.net/GetAuthToken";
      this.apiKey =
        "ZobDp9r6hqkh3HK9Iem1Rq7TvmA_PqKZR96DQtqPhmc=:gAAAAABnyY-8YajcTtQfoX-N5Cku99shT3wXI4h1DqmhlEOC53IKuiSJug5gki1c5dbZrQlX5t_qAhecdOCHyU6girMmf6pXVD8dt0XfYJkU-7C0N-ch0jTjc_IkqhHDhF2z6Qt8nSlYnK1VpMV_t2URJRcjrCKDqMXjUIRJaGF2GrgJps-Cs90=";
    }

    const headers = {
      Authorization: `Bearer ${this.apiKey}`,
    };

    return fetch(this.apiUrl, { headers })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch token: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => data.bearer) // Use `data.bearer` to get the token
      .catch((error) => {
        console.error("Error fetching auth token:", error);
        throw error;
      });
  }

  generateNonce(): string {
    try {
      const array = new Uint8Array(16);
      window.crypto.getRandomValues(array);

      const nonce = btoa(String.fromCharCode(...array)).replace(/=+$/, "");
      return nonce;
    } catch (error) {
      throw error;
    }
  }

  generateSignature(timestamp: string, nonce: string): string {
    const stringToSign = `${this.client_id}:${timestamp}:${nonce}`;
    const signature = CryptoJS.HmacSHA256(
      stringToSign,
      this.client_secret,
    ).toString(CryptoJS.enc.Base64); // HMAC-SHA256 signature
    return signature;
  }

  getNewAuthToken() {
    this.apiUrl =
      "https://us-west2-center-store-inventory-dev.cloudfunctions.net/GetAuthToken";

    if (this.util.isProd()) {
      this.apiUrl =
        "https://us-west2-center-store-inventory-prod.cloudfunctions.net/GetAuthToken";
      this.client_id = "1092806948147";
      this.client_secret =
        "g7913e54fa4a50fd95340ht7f1746c716d3156e918hc6hhyf204e772210408v";
    }

    const timestamp = Math.floor(Date.now() / 1000).toString();
    const nonce = this.generateNonce();
    const signature = this.generateSignature(timestamp, nonce);
    this.util.setlocation(location);
    const credentials = btoa(`${this.client_id}:${this.client_secret}`);

    const headers = {
      Authorization: `Basic ${credentials}`,
      timestamp: timestamp,
      nonce: nonce,
      signature: signature,
    };

    return fetch(this.apiUrl, { headers })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch token: ${response.statusText}`);
        }
        return response.json();
      })
      .then((data) => data.bearer) // Use `data.bearer` to get the token
      .catch((error) => {
        console.error("Error fetching auth token:", error);
        throw error;
      });
  }
}
